import Client from '../message-broker/Client';
import store from '../../store';
import CallAction from '../actions/CallAction';

export default class PingChatvisorBrokerEvent {
  constructor() {
    const queueAgent = store.state.system.queueListenerMessageBroker;
    const agentId = store.state.attendance.Attendance.agentId;
    const queuesToSend = ['CHATVISOR'];
    queuesToSend.forEach((queue) => {
      new Client(queueAgent).client.send(
        queue,
        null,
        JSON.stringify(CallAction.sendPongChatvisorBrokerAction(agentId)),
      );
    });
    // store.dispatch('setLastPingEvent')
  }
}
